/**
 * Enum trạng thái ban hành danh mục
 * nnduc 1/4/2024
 */
export default {
  // tất cả
  All: 0, 
  // Thêm mới
  AddNew: 1, 
  // Đã sửa
  Updated: 2, 
  // Đã ban hành
  Enacted: 3, 
  //Đã xóa
  Deleted: 4,
  //Hủy ban hành
  Cancel:5 
};
